import { render, staticRenderFns } from "./DashboardNav.vue?vue&type=template&id=a04bf99e&"
import script from "./DashboardNav.vue?vue&type=script&lang=js&"
export * from "./DashboardNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports